import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import i18next from 'i18next';

const ErrorBoundaryFallbackRender = ({ error }) => {
  const isChunkError =
    error?.name === 'ChunkLoadError' ||
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes('ChunkLoadError');

  const handleReloadPage = () => {
    window.location.href = '/';
  };

  return (
    <Box className="flex flex-col items-center justify-center min-h-screen p-6 bg-white min-w-screen dark:bg-darker">
      <div className="w-full max-w-md py-32 text-center bg-white shadow-xl dark:bg-dark rounded-2xl">
        <img
          className="block h-32 mx-auto mb-6"
          src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo-with-text.svg`}
          alt="logo"
        />
        {isChunkError ? (
          <div className="p-10">
            <p className="flex justify-center w-[100%]">
              <FuseSvgIcon size={50} className="text-blue-500 mb-4">
                react-outline:information-circle
              </FuseSvgIcon>
            </p>
            <h1 className="mb-3 text-2xl font-bold text-gray-800 dark:text-white">
              {i18next.t('UpdateSystem', { ns: 'translations' })}
            </h1>
            <p className="text-gray-500 dark:text-gray-300">
              {i18next.t('UpdateSystemDesc', { ns: 'translations' })}
            </p>
            <button
              onClick={handleReloadPage}
              className="px-6 py-4 mt-6 font-medium text-white bg-blue-700 rounded-sm hover:bg-blue-800"
            >
              {i18next.t('Reload', { ns: 'translations' })}
            </button>
          </div>
        ) : (
          <>
            <p className="flex justify-center w-[100%] text-red-600">
              <FuseSvgIcon size={50}>react-outline:exclamation-circle</FuseSvgIcon>
            </p>
            <h1 className="mb-4 text-2xl font-bold text-grey-800 dark:text-white">
              {i18next.t('AnErrorOccurred', { ns: 'translations' })}
            </h1>
            <p className="mb-2 text-grey-500 dark:text-white">
              {i18next.t('Excusme', { ns: 'translations' })},
              {i18next.t('AnUnexpectedErrorOccurredInTheSystem', { ns: 'translations' })}
            </p>
            {error && (
              <Accordion className="bg-transparent px-16 border-0 border-b-[1px] border-b-[#E6E5E7] dark:border-b-[#444444]">
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="text-black dark:text-white text-20" />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography component="p" className="text-black dark:text-white text-13">
                    {i18next.t('Error', { ns: 'translations' })}:
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography component="p" className="text-sm text-red-600 whitespace-pre-wrap">
                    {error?.name} {error?.message}
                  </Typography>
                  <Typography component="p" className="text-sm text-red-600 whitespace-pre-wrap">
                    {error?.stack}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )}
            <button
              onClick={handleReloadPage}
              className="px-20 py-10 mt-10 font-medium text-white bg-blue-700 rounded-lg"
            >
              {i18next.t('ReturnToTheHomepage', { ns: 'translations' })}
            </button>
          </>
        )}
      </div>
    </Box>
  );
};

export default ErrorBoundaryFallbackRender;
